import { useSelector } from "react-redux";
import DefaultUpdater from "../../../common/DefaultUpdater";

import classes from './NoAttorney.module.css'
import { attorneyStatusUnattached } from "../../../../lib/systemData";
import DayOneAttyStatus from "./DayOneAttyStatus";
import FastHelpCheckbox from "./FastHelpCheckbox";


export default function NoAttorney() {
    const activeCase = useSelector(state => state.case.activeCase)  

    return <div className={classes.container}>
        <p>Reason for no attorney on file</p>
        <DefaultUpdater type={'select'} value={activeCase?.additional?.no_attorney_reason} options={attorneyStatusUnattached()} label={'Reason'} identifier={{type: 'case_additional', field: 'no_attorney_reason', folder: 'additional', permissionType: 'case_attorney'}}/>
        <DayOneAttyStatus case_kpi={activeCase?.case_kpi}/>
        <FastHelpCheckbox additional={activeCase?.additional}/>
    </div>
}
